<template>
  <div class="d-flex justify-space-between">
    <display-icon-badge-tooltip
      v-if="icon"
      :icon="icon"
      :tooltip-text="iconTooltip"
    />
    <div class="d-flex font-weight-bold text-center align-self-center">
      {{ title }}
      <slot />
    </div>
    <div class="subtitle-2 font-italic text-right">
      {{ date && date.toLocaleString() }}
    </div>
  </div>
</template>
<script>
import DisplayIconBadgeTooltip from '@/components/displays/DisplayIconBadgeTooltip';

export default {
  name: 'display-card-head',
  components: { DisplayIconBadgeTooltip },

  props: {
    date: { type: Date, required: false },
    icon: {
      type: String,
      required: false,
    },
    iconTooltip: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
};
</script>
